import React from 'react';
import SMCPage from '../components/core/pageComponents/SMCPage';
import {useTranslation} from 'react-i18next';
import RowLayout from '../components/Layouts/RowLayout';
import SMCButton from '../components/Simple/SMCButton';
import SMCLabel from '../components/Simple/SMCLabel';
import { makeStyles } from '@mui/styles';
import {useBoolean} from '../utils/hooks';
import ExportSMPModal from './PopupPages/ExportSMPModal';
import ImportSMPModal from './PopupPages/ImportSMPModal';
import EmptyRow from '../components/Simple/EmptyRow';
import {helpContextPageUrl} from '../conf/Routes';


function Tools() {
    const { t } = useTranslation();
    const classes = useStyles();

    const [isExportModalOpen, openExportModal, closeExportModal] = useBoolean(false);
    const [isImportModalOpen, openImportModal, closeImportModal] = useBoolean(false);

    return (
        <SMCPage helpId={helpContextPageUrl.tools}>
            <div className={classes.operationsTableRoot}>
                <RowLayout center className={classes.operationsTableHeader}>
                    {t('SMC_SYSOPS_TABLE')}
                </RowLayout>
                <div className={classes.operationsTableBody}>
                    <RowLayout height={40}>
                        <SMCLabel width={320}>{t('SMC_SYSOPS_EXPORT_TEXT')}</SMCLabel>
                        <SMCButton onClick={openExportModal}>{t('SMC_SYSOPS_EXPORT')}</SMCButton>
                    </RowLayout>
                    <RowLayout height={40}>
                        <SMCLabel width={320}>{t('SMC_SYSOPS_IMPORT_TEXT')}</SMCLabel>
                        <SMCButton onClick={openImportModal}>{t('SMC_SYSOPS_IMPORT')}</SMCButton>
                    </RowLayout>
                </div>
            </div>
            {/* Popup pages */}
            <ExportSMPModal
                isOpen={isExportModalOpen}
                onRequestClose={closeExportModal}
            />
            <ImportSMPModal
                isOpen={isImportModalOpen}
                onRequestClose={closeImportModal}
            />
            <EmptyRow />
            <SMCLabel>{t('SMC_SYSOPS_BOTTOM_TEXT')}</SMCLabel>
        </SMCPage>
    );
}

const useStyles = makeStyles({
    operationsTableRoot: {
        width: 420,
        border: '1px solid #CFCFD2'
    },
    operationsTableHeader: {
        width: '100%',
        height: 28,
        background: '#F7F7F7',
        color: '#384C6E',
        fontWeight: 'bold'
    },
    operationsTableBody: {
        background: 'white',
        padding: '7px'
    },
});

export default Tools;